var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30005 25.3H21.8V22.2H6.30005V25.3ZM21.8 19.1H6.30005V16H21.8V19.1Z",
    fill: "#0080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30005 12.9H12.5V9.80002H6.30005V12.9Z",
    fill: "#0080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7501 0.5C3.51684 0.5 2.3341 0.989909 1.46205 1.86195C0.590007 2.734 0.100098 3.91674 0.100098 5.15V26.85C0.100098 28.0833 0.590007 29.266 1.46205 30.138C2.3341 31.0101 3.51684 31.5 4.7501 31.5H23.3501C24.5834 31.5 25.7661 31.0101 26.6381 30.138C27.5102 29.266 28.0001 28.0833 28.0001 26.85V11.35C28.0001 8.4724 26.857 5.71266 24.8222 3.67789C22.7874 1.64312 20.0277 0.5 17.1501 0.5H4.7501ZM4.7501 3.6H15.6001V11.35H24.9001V26.85C24.9001 27.2611 24.7368 27.6553 24.4461 27.946C24.1554 28.2367 23.7612 28.4 23.3501 28.4H4.7501C4.33901 28.4 3.94476 28.2367 3.65408 27.946C3.3634 27.6553 3.2001 27.2611 3.2001 26.85V5.15C3.2001 4.73891 3.3634 4.34467 3.65408 4.05398C3.94476 3.7633 4.33901 3.6 4.7501 3.6V3.6ZM18.7001 3.755C19.9184 4.00458 21.0589 4.54315 22.0256 5.32539C22.9923 6.10762 23.757 7.11063 24.2553 8.25H18.7001V3.755Z",
    fill: "#0080FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f4c52cc49c3a5f3b4ac20227ea97ac58.svg";
export { ForwardRef as ReactComponent };